import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-cb044542"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "company-info"
};
const _hoisted_2 = {
  class: "company-info__title"
};
const _hoisted_3 = {
  class: "logo-wrapper"
};
const _hoisted_4 = {
  class: "empty-placeholder"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("hr", {
  class: "company-info__hr"
}, null, -1));
const _hoisted_6 = {
  class: "company-info__section-wrapper"
};
const _hoisted_7 = {
  class: "company-info__section-title"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _ctx$companyInfo, _ctx$companyInfo2, _ctx$companyInfo3;
  const _component_t_image = _resolveComponent("t-image");
  const _component_v_node_render = _resolveComponent("v-node-render");
  const _component_ellipsis_text = _resolveComponent("ellipsis-text");
  const _component_t_description_item = _resolveComponent("t-description-item");
  const _component_t_description = _resolveComponent("t-description");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_t_image, {
    "img-src": ((_ctx$companyInfo = _ctx.companyInfo) === null || _ctx$companyInfo === void 0 ? void 0 : _ctx$companyInfo.logo) && _ctx.createProtocolUrl(_ctx.companyInfo.logo) || '',
    "placeholder-img-src": _ctx.getCompanyDefaultLogo((_ctx$companyInfo2 = _ctx.companyInfo) === null || _ctx$companyInfo2 === void 0 ? void 0 : _ctx$companyInfo2.company_name) || require('@/assets/img/customer/company-logo.png')
  }, null, 8, ["img-src", "placeholder-img-src"])]), _createElementVNode("h1", _hoisted_4, _toDisplayString((_ctx$companyInfo3 = _ctx.companyInfo) === null || _ctx$companyInfo3 === void 0 ? void 0 : _ctx$companyInfo3.company_name), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.infoConfig, config => {
    return _openBlock(), _createElementBlock(_Fragment, {
      key: config.title
    }, [_hoisted_5, _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString(config.title), 1), _createVNode(_component_t_description, {
      direction: "vertical",
      column: config.column,
      gutter: [8, 34]
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.info, infoItem => {
        return _openBlock(), _createBlock(_component_t_description_item, {
          key: infoItem.label,
          span: infoItem.span,
          label: infoItem.label,
          "label-class-name": "company-info__label",
          "content-class-name": "company-info__content"
        }, {
          default: _withCtx(() => [infoItem.render ? (_openBlock(), _createBlock(_component_v_node_render, {
            key: 0,
            vnode: infoItem.render()
          }, null, 8, ["vnode"])) : (_openBlock(), _createBlock(_component_ellipsis_text, {
            key: 1,
            contentClass: "empty-placeholder"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(infoItem.value || ''), 1)]),
            _: 2
          }, 1024))]),
          _: 2
        }, 1032, ["span", "label"]);
      }), 128))]),
      _: 2
    }, 1032, ["column"])])], 64);
  }), 128))]);
}